import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-technical-health-overview',
  templateUrl: './technical-health-overview.component.html',
  styleUrls: ['./technical-health-overview.component.css']
})
export class TechnicalHealthOverviewComponent {
  @Input() data: any = {
    avgScore: 0,
    healthy: 0,
    warning: 0,
    critical: 0
  };

  get healthClass() {
    if (!this.data) return 'text-muted';
    if (this.data.avgScore >= 80) return 'text-success';
    if (this.data.avgScore >= 50) return 'text-warning';
    return 'text-danger';
  }
}
